module.exports = __webpack_public_path__ + "img/burger-cheese.a5c57590.svg";